import { render, staticRenderFns } from "./OriginGoodItem.vue?vue&type=template&id=68a8ba8a&scoped=true"
import script from "./OriginGoodItem.vue?vue&type=script&lang=js"
export * from "./OriginGoodItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a8ba8a",
  null
  
)

export default component.exports